import { base } from 'viem/chains'
import { parseUnits } from 'viem'

// mapped to decimal places
export const UNIT = {
  WEI: 0,
  KWEI: 3, // eslint-disable-line sort-keys
  MWEI: 6,
  GWEI: 9, // eslint-disable-line sort-keys
  SZABO: 12,
  FINNEY: 15, // eslint-disable-line sort-keys
  ETHER: 18, // eslint-disable-line sort-keys
}

export const USDC_DATA = {
  address: '0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913',
  allowance: 0n,
  allowanceFormatted: '$0',
  allowanceFormattedCompact: '$0',
  amount: 0n,
  amountFormatted: '$0',
  amountFormattedCompact: '$0',
  symbol: 'USDC',
}

export const GAS_DATA = {
  amount: 0n,
  amountFormatted: '0',
  amountFormattedCompact: '0',
  symbol: 'ETH',
}

export const LOCK_DATA = {
  amount: 0n,
  amountFormatted: '$0',
  amountFormattedCompact: '$0',
  symbol: 'lUSDC',
}

export const BALANCE_DATA = {
  amount: 0n,
  amountFormatted: '$0',
  amountFormattedCompact: '$0',
  amountMwei: 0,
  symbol: 'USDC',
  trend: 0, // generic number comparison: 1 when it increased, -1 when it decreased, 0 when it remained the same
}

export const WALLET_UPDATE_INTERVAL = 60 * 1000
export const WALLET_ALLOWANCE_AMOUNT = parseUnits('1000', UNIT.MWEI)
export const WALLET_ALLOWANCE_THRESHOLD = parseUnits('100', UNIT.MWEI)
export const WALLET_GAS_CHECK_THRESHOLD = parseUnits('0.000005', UNIT.ETHER)

export const WALLET_SEND_AMOUNT_MIN = 0.01
export const WALLET_SEND_AMOUNT_DEFAULT = 1

export const WALLET_HOURLY_RATE_MIN_SECONDS_TO_AFFORD = 30n
export const WALLET_HOURLY_RATE_WARNING_THRESHOLD = 60n

export const CHAIN = {
  ...base,
  fees: {
    // https://viem.sh/docs/chains/fees
    ...base.fees,
    baseFeeMultiplier: 0.5,
  },
}

export const ABI = [
  {
    inputs: [
      {
        internalType: 'address',
        name: 'owner',
        type: 'address',
      },
      {
        internalType: 'address',
        name: 'spender',
        type: 'address',
      },
    ],
    name: 'allowance',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'spender',
        type: 'address',
      },
      {
        internalType: 'uint256',
        name: 'value',
        type: 'uint256',
      },
    ],
    name: 'approve',
    outputs: [
      {
        internalType: 'bool',
        name: '',
        type: 'bool',
      },
    ],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'account',
        type: 'address',
      },
    ],
    name: 'balanceOf',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'to',
        type: 'address',
      },
      {
        internalType: 'uint256',
        name: 'value',
        type: 'uint256',
      },
    ],
    name: 'transfer',
    outputs: [
      {
        internalType: 'bool',
        name: '',
        type: 'bool',
      },
    ],
    stateMutability: 'nonpayable',
    type: 'function',
  },
]
